export const stripHtmlTags = (str: string): string => str.replace(/<\/?[^>]+(>|$)|&nbsp;/g, '');
